<div class="govuk-width-container">
    <div class="row">
        <nav class="col-12 col-md-4" aria-label="Side navigation">
            <p class="govuk-body h-100"><app-menu></app-menu></p>
        </nav>
        <main class="govuk-main-wrapper col-12 col-md-8 pt-0" id="main-content" tabindex="-1">
            <h1 class="govuk-heading-xl">Payment Information</h1>

            <div *ngIf="paymentResult === 'success'"
                 class="govuk-notification-banner govuk-notification-banner--success app-notification-banner"
                 role="alert"
                 aria-labelledby="payment-result-success-title"
                 data-module="govuk-notification-banner"
                 data-test="payment-result-success">
                <div class="govuk-notification-banner__header">
                    <h2 class="govuk-notification-banner__title" id="payment-result-success-title">
                        Success
                    </h2>
                </div>
                <div class="govuk-notification-banner__content">
                    <p class="govuk-notification-banner__heading">Payment successful. Your payment has been received.</p>
                </div>
            </div>

            <div *ngIf="paymentResult === 'failed'"
                 class="govuk-notification-banner app-notification-banner"
                 role="alert"
                 aria-labelledby="payment-result-failed-title"
                 data-module="govuk-notification-banner"
                 data-test="payment-result-failed">
                <div class="govuk-notification-banner__header">
                    <h2 class="govuk-notification-banner__title" id="payment-result-failed-title">
                        Important
                    </h2>
                </div>
                <div class="govuk-notification-banner__content">
                    <p class="govuk-notification-banner__heading">Payment unsuccessful. We could not confirm your payment. Please try again or contact the registrars team.</p>
                </div>
            </div>

            <div *ngIf="revCodeError"
                 class="govuk-notification-banner app-notification-banner"
                 role="alert"
                 aria-labelledby="payment-rev-code-error-title"
                 data-module="govuk-notification-banner"
                 data-test="payment-rev-code-error">
                <div class="govuk-notification-banner__header">
                    <h2 class="govuk-notification-banner__title" id="payment-rev-code-error-title">
                        Important
                    </h2>
                </div>
                <div class="govuk-notification-banner__content">
                    <p class="govuk-notification-banner__heading">
                        If you experience any problems with making a payment for your ceremony, please contact us. The best way is your
                        <a class="govuk-link govuk-notification-banner__link" [routerLink]="communicationLink">myWestminster</a> account.
                    </p>
                </div>
            </div>

            <div *ngIf="paymentStartError"
                 class="govuk-notification-banner app-notification-banner"
                 role="alert"
                 aria-labelledby="payment-start-error-title"
                 data-module="govuk-notification-banner"
                 data-test="payment-start-error">
                <div class="govuk-notification-banner__header">
                    <h2 class="govuk-notification-banner__title" id="payment-start-error-title">
                        Important
                    </h2>
                </div>
                <div class="govuk-notification-banner__content">
                    <p class="govuk-notification-banner__heading">
                        We could not start your payment, so you have not been charged. Select
                        &ldquo;Start again&rdquo; to reload your account and try again, or contact us via your
                        <a class="govuk-link govuk-notification-banner__link" [routerLink]="communicationLink">myWestminster</a> account if the problem continues.
                    </p>
                </div>
            </div>

            <div *ngIf="refundDue > 0"
                 class="govuk-notification-banner app-notification-banner"
                 role="region"
                 aria-labelledby="refund-due-title"
                 data-module="govuk-notification-banner"
                 data-test="refund-due">
                <div class="govuk-notification-banner__header">
                    <h2 class="govuk-notification-banner__title" id="refund-due-title">
                        Important
                    </h2>
                </div>
                <div class="govuk-notification-banner__content">
                    <p class="govuk-notification-banner__heading">
                        You are due a refund of {{ refundDueDisplay }}.
                    </p>
                    <p class="govuk-body">
                        Please <a class="govuk-link govuk-notification-banner__link" href="https://www.westminster.gov.uk/register-office-refund" target="_blank" rel="noopener noreferrer">submit a refund request</a>.
                    </p>
                    <p class="govuk-body">
                        Approved refunds are returned to the card you used to book, usually within 3 to 5 days.
                    </p>
                </div>
            </div>

            <div class="govuk-notification-banner app-notification-banner" role="region" aria-labelledby="govuk-notification-banner-title"
                data-module="govuk-notification-banner">
                <div class="govuk-notification-banner__header">
                    <h2 class="govuk-notification-banner__title" id="govuk-notification-banner-title">
                        Important Payment Information
                    </h2>
                </div>
                <div class="govuk-notification-banner__content">
                    <p class="govuk-notification-banner__heading">Ceremony fees must be paid at least 3 months before your ceremony date.</p>
                        <!-- <span *ngIf="purchase">
                            Your outstanding balance is {{ priceMinusPaidDisplay }}
                        </span> -->
                </div>
            </div>
            <app-custom-object-banner page="payment-information"></app-custom-object-banner>

            <ng-container *ngIf="ceremonyFees.length > 0">
              <h2>Fee breakdown</h2>
              <table class="govuk-table">
                  <caption class="govuk-visually-hidden">Fee breakdown</caption>
                  <thead class="govuk-table__head">
                      <tr class="govuk-table__row">
                          <th scope="col" class="govuk-table__header" style="width: 50%">Item</th>
                          <th scope="col" class="govuk-table__header" aria-hidden="true">&nbsp;</th>
                          <th scope="col" class="govuk-table__header" style="width:20%">Price</th>
                      </tr>
                  </thead>
                  <tbody class="govuk-table__body">
                      <tr class="govuk-table__row" *ngFor="let row of ceremonyFees">
                          <td class="govuk-table__cell" style="width: 50%">{{ row.displayItem || row.data?.item }} 
                            <span *ngIf="row.data?.quantity > 1">&#40;x{{row.data?.quantity}}&#41;</span></td>
                          <td class="govuk-table__cell">&nbsp;</td>
                          <td class="govuk-table__cell price-cell">
                              <ng-container *ngIf="!row.included; else includedPrice">
                                  <span>{{ row.price[0] }}</span>
                                  <span>{{ row.price[1] }}</span>
                              </ng-container>
                              <ng-template #includedPrice><span class="price-included">Included</span></ng-template>
                          </td>
                      </tr>
                      <tr class="govuk-table__row">
                          <th scope="col" class="govuk-table__header" style="width: 50%">Total</th>
                          <td class="govuk-table__cell">&nbsp;</td>
                          <td class="govuk-table__cell"><strong class="price-cell" *ngIf="totalPriceDisplay">
                              <span>{{ totalPriceDisplay[0] }}</span>
                              <span>{{ totalPriceDisplay[1] }}</span></strong>
                          </td>
                      </tr>
                  </tbody>
              </table>
            </ng-container>

            <!-- 2025-04-17 - Table removed due to outstanding issues with JRNI's purchase payment API. -->
            <!-- 2025-04-22 - Table put back to tets fixes in JRNI's purchase payment API. -->
            <h2>Payments made</h2>
            <table class="govuk-table">
                <caption class="govuk-visually-hidden">Payments made</caption>
                <thead class="govuk-table__head">
                    <tr class="govuk-table__row">
                        <th scope="col" class="govuk-table__header" style="width: 50%">Item</th>
                        <th scope="col" class="govuk-table__header">Date</th>
                        <th scope="col" class="govuk-table__header" style="width:20%">Amount</th>
                    </tr>
                </thead>
                <tbody class="govuk-table__body">
                    <tr class="govuk-table__row" *ngFor="let purchase of purchaseHistory">
                        <td class="govuk-table__cell" style="width: 50%">{{ purchase.notes }}</td>
                        <td class="govuk-table__cell">{{ purchase.date }}</td>
                         <td class="govuk-table__cell price-cell">
                            <span>{{ purchase.amount[0] }}</span>
                            <span>{{ purchase.amount[1] }}</span></td>
                    </tr>
                    <tr class="govuk-table__row">
                        <th scope="col" class="govuk-table__header" style="width: 50%">Total</th>
                        <td class="govuk-table__cell">&nbsp;</td>
                        <td class="govuk-table__cell"><strong class="price-cell" *ngIf="purchaseHistoryTotalDisplay">
                            <span>{{ purchaseHistoryTotalDisplay[0] }}</span>
                            <span>{{ purchaseHistoryTotalDisplay[1] }}</span></strong>
                        </td>
                    </tr>
                </tbody>
            </table>

            <!-- <h2>Make a payment</h2>

            <p class="govuk-body">Please select from one of the options below to make a payment. You will need
                your debit/credit card ready to make your payment online. </p> -->

            <div class="govuk-button-group">
                <button type="button" class="govuk-button govuk-button--secondary" data-module="govuk-button"
                    *ngIf="showInstallments" (click)="pay('installments')">
                    Make instalment payment (min. £50)
                </button>
                <button type="button" class="govuk-button govuk-button--secondary" data-module="govuk-button"
                    *ngIf="showBalance && purchase && balanceOutstanding > 0 && !paymentStartError" (click)="pay('balance')">
                    Pay outstanding balance
                </button>
                <button type="button" class="govuk-button govuk-button--secondary" data-module="govuk-button"
                    *ngIf="paymentStartError" (click)="restart()">
                    Start again
                </button>
                <button type="button" class="govuk-button govuk-button--secondary" data-module="govuk-button"
                    *ngIf="showInstallments" (click)="pay('extra_items')">
                    Purchase optional extras
                </button>
            </div>
            <ng-container *ngIf="paying">
                <app-payment-amount *ngIf="ceremonyFees.length > 0" [action]="paymentAction" [paymentType]="paymentProvider"
                    [amount]="(paymentAction === 'balance') ? balanceOutstanding : 50"
                    [outstanding]="balanceOutstanding" [booking]="booking" [bookingLinks]="reconciledFees"
                    [service]="service"></app-payment-amount>
                <p class="govuk-body-s" *ngIf="ceremonyFees.length === 0">
                    There is an issue with paying for your ceremony online. Please contact the registrars team via the Contact Us button on this page.
                </p>
                <hr>
            </ng-container>
        </main>
    </div>

</div>
